const ACRONYMS = ['SMS'];

export const titleize = (string: string | undefined | null) =>
  !string
    ? ''
    : string
        .toLowerCase()
        .replace(/_/g, ' ')
        .replace(/(?:^|\s|-)\S/g, character => character.toUpperCase())
        .replace(new RegExp(`(?:^|\\s|-)(?:${ACRONYMS.join('|')})(?:$|\\s|-)`, 'gi'), word =>
          word.toUpperCase()
        );
